import React, { useRef } from "react";
import BtnRequestTour from "../../../../../components/Section/RequestTour";
import { AWS_BASE_URL } from "../../../../../clientConfig";
import BtnContactAgent from "../../../../../components/Section/ContactAnAgent";
import { dateTimeFormat, getLocalStorage } from "../../../../../utils";
import { USER_ROUTES } from "../../../../../constants/appRoutes";
import { useNavigate } from "react-router-dom";

interface ClientEnquirySectionProps {
  projectData: any;
  className?: string;
  btnRequestClassName?: string;
  btnContactClassName?: string;
  alreadyRequestTour: any;
  setAlreadyRequestTour: any;
}

const ClientEnquirySection: React.FC<ClientEnquirySectionProps> = ({
  projectData,
  className,
  btnRequestClassName,
  btnContactClassName,
  alreadyRequestTour,
  setAlreadyRequestTour,
}) => {
  const userId = getLocalStorage("userId");
  const alreadyRequestId = [0, 1];

  const meetingIdRef = useRef(projectData?.meeting_id);

  const checkAlReadyTour = alreadyRequestId.includes(alreadyRequestTour);

  const navigate = useNavigate();

  const handleCheckCurrentAgent = (): boolean => {
    return userId === projectData?.agent?._id;
  };

  const handleCheckCurrentBuilder = (): boolean => {
    return projectData?.builders?.some(
      (builder: any) => builder?._id === userId
    );
  };

  return (
    <div className={className}>
      {projectData?.agent?._id &&
      !(
        projectData?.total_sold_units >=
        (projectData?.total_flats || projectData?.total_houses)
      ) ? (
        <>
          {!handleCheckCurrentAgent() && !handleCheckCurrentBuilder() ? (
            <BtnRequestTour
              initialData={{
                project_id: projectData?._id || "",
              }}
              agentId={projectData?.agent?._id}
              imageUrl={`${AWS_BASE_URL}${projectData?.project_images?.images?.[0]?.image}`}
              modelTitle={projectData?.name}
              btnClassName={`h-fit w-full lg:w-max ${btnRequestClassName}`}
              alreadyTour={checkAlReadyTour}
              handleApiResponse={(meetingId: string) => {
                meetingIdRef.current = meetingId;
                setAlreadyRequestTour(0);
              }}
              btnOnClick={() => {
                if (checkAlReadyTour) {
                  navigate(
                    `${USER_ROUTES.MANAGE_TOURS}/view/${meetingIdRef.current ?? projectData?.meeting_id}`
                  );
                }
              }}
            >
              {/* Request Tour */}
              {checkAlReadyTour ? (
                <div>
                  <div className="font-bold text-lg leading-6">
                    {alreadyRequestTour == 0 ? (
                      <span>Already requested for tour</span>
                    ) : null}
                  </div>
                  {projectData?.meeting_status === 1 &&
                  projectData?.meeting_slot?.date &&
                  projectData?.meeting_slot?.time ? (
                    <p className="text-base leading-3">
                      <span className="block mb-4">Tour Scheduled At:</span>
                      {dateTimeFormat(
                        projectData?.meeting_slot?.date,
                        "DD-MM-YYYY"
                      )}{" "}
                      {projectData?.meeting_slot?.time}
                    </p>
                  ) : null}
                </div>
              ) : (
                <div className="font-medium  xs:font-bold xs:text-lg leading-6">
                  Request a tour
                </div>
              )}
            </BtnRequestTour>
          ) : null}
        </>
      ) : null}
      {!handleCheckCurrentAgent() && !handleCheckCurrentBuilder() ? (
        <BtnContactAgent
          className={`h-fit w-max lg:w-max leading-6 ${btnContactClassName}`}
          initialData={{
            project_id: projectData?._id,
          }}
        >
          Contact an agent
        </BtnContactAgent>
      ) : null}
    </div>
  );
};

export default ClientEnquirySection;
